import { Flex } from "@daangn/carotene";
import clsx from "clsx";
import React from "react";

import { breakAll } from "~/design-system/css/breakAll.css";

import * as css from "./Callout.css";

type Props = {
  badge?: React.ReactNode;
  labelVariant: "primary" | "neutral" | "accent" | "undefined";
  content: string;
  border?: boolean;
};

export default function Callout({ border = true, ...props }: Props) {
  return (
    <Flex className={css.container({ border })}>
      {props.badge && <div>{props.badge}</div>}
      <div>
        <span className={css.label({ variant: props.labelVariant })}>
          단골 혜택
        </span>
        <span className={clsx(css.content, breakAll)}>{props.content}</span>
      </div>
    </Flex>
  );
}
